export default __webpack_public_path__ + "static/media/gplay-full.9fe9275f.svg";